"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageRegistry = void 0;
class MessageRegistry {
    constructor() {
        this.registeredMsgType = new Map();
    }
    registerMessage(msgCls) {
        if (this.registeredMsgType.has(msgCls.type())) {
            throw new Error(`Already registered type ${msgCls.type()}`);
        }
        this.registeredMsgType.set(msgCls.type(), msgCls);
    }
    parseMessage(message) {
        if (!message.type) {
            throw new Error("Null type");
        }
        const msgCls = this.registeredMsgType.get(message.type);
        if (!msgCls) {
            throw new Error(`Unregistered msg type ${message.type}`);
        }
        return Object.setPrototypeOf(message.msg, msgCls.prototype);
    }
}
exports.MessageRegistry = MessageRegistry;
//# sourceMappingURL=index.js.map